<template>
  <mdb-container v-if="currentGroup" class="gp-has-header">
    <h3>Event Calendar For {{ currentGroup.name }}</h3>
    <div id="tooltip" style="display:none"></div>
    <div class="top-buttons">
      <router-link to="/calendar">Go to My Calendar</router-link>
      <mdb-btn floating icon="print" tag="a" size="sm" @click="print" title="Print"/>
      <mdb-btn v-if="currentGroup.role == 'Admin' ||
                     currentGroup.role == 'Group Organizer' ||
                     currentGroup.role == 'Event Organizer'" floating icon="plus-circle" size="sm"
               tag="a" title="Add Note"
               @click="addNote"/>
    </div>
    <full-calendar :events="events"
                   defaultView="dayGridMonth"
                   :plugins="calendarPlugins"
                   :weekends=true
                   :header="header"
                   :event-time-format="userTimeFormat"
                   :editable="false"
                   :draggable="false"
                   :first-day="userDetails.mondayFirst ? 1 : 0"
                   :event-limit="true"
                   :nav-links="true"
                   @eventMouseEnter="mouseEnter"
                   @eventMouseLeave="mouseExit"
                   @eventClick="eventClick"
                   ref="calendar"
    />
    <div class="text-right">
      <mdb-input type="checkbox" v-if="currentGroup.role == 'Admin' ||
                     currentGroup.role == 'Group Organizer' ||
                     currentGroup.role == 'Event Organizer'"
                 v-model="includeTasks" id="includeTasks"
                 label="Include Tasks"
      />
    </div>
    <div>You can subscribe to your <i>personal</i> calendar on Google, iCal and others via a link <router-link to="/user/profile?tab=calendar">from your profile</router-link>.</div>
    <div class="bottom-buttons">
      <router-link to="/calendar">Go To My Calendar</router-link>
      <mdb-btn floating icon="print" tag="a" size="sm" @click="print" title="Print"/>
      <mdb-btn v-if="currentGroup.role == 'Admin' ||
                     currentGroup.role == 'Group Organizer' ||
                     currentGroup.role == 'Event Organizer'" floating icon="plus-circle" size="sm"
               tag="a" title="Add Note"
               @click="addNote"/>
    </div>

    <mdb-modal @close="showNoteEdit = false" v-if="showNoteEdit" size="lg">
      <mdb-modal-header :close="true" class="primary-color text-white">
        <h3>Note</h3>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <mdb-input id="noteTitle" label="Title" placeholder="Title" v-model="workingNote.title"/>
        <label class="active mr-5">Date</label>
        <datetime :format="userDetails.dateFormat"
                  :valueZone="userDetails.timezone" :weekStart="userDetails.mondayFirst ? 1 : 7"
                  inputId="startDate" type="date"
                  :auto="true"
                  v-model="workingNote.startDate">
        </datetime>
        <br/>
        <label class="active mr-5">End Date</label>
        <div class="small text-info">
          To span multiple days, the end date should be the first day it should <i>not</i> show.
          For example, and event that happens from June 1-3, use June 4 as the end date.
        </div>
        <datetime :format="userDetails.dateFormat"
                  :valueZone="userDetails.timezone" :weekStart="userDetails.mondayFirst ? 1 : 7"
                  inputId="endDate" type="date"
                  :auto="true"
                  v-model="workingNote.endDate">
        </datetime>

        <br/>
        <label class="active mr-5">Note Color</label>
        <compact v-model="colors" @input="colorChange"/>

        <editor :init="editorConfig" v-model="workingNote.text">
        </editor>
        <mdb-btn @click="saveNote" :disabled="!workingNote.title || !workingNote.startDate">
          <mdb-icon icon="save"/>
          Save
        </mdb-btn>
        <mdb-btn @click="showNoteEdit = false">
          <mdb-icon icon="window-close"/>
          Cancel
        </mdb-btn>
        <mdb-btn @click="deleteRequested=true" icon="trash" color="danger" v-if="workingNote.id">
          Delete
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <yes-no-modal v-if="deleteRequested" @yes="doDeleteNote" @no="deleteRequested=false"
                  question="Delete this note?"/>

    <mdb-modal :show="showModal" @close="showModal=false" size="lg">
      <mdb-modal-header :close="true" class="primary-color text-center text-white">
        <h5>{{ noteTitle }}</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div v-html="noteBody"/>
      </mdb-modal-body>
      <mdb-modal-footer v-if="allowNoteEdit">
        <mdb-btn size="sm" rounded @click="editNote" icon="pencil">Edit</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'

import {mdbBtn, mdbContainer, mdbIcon, mdbInput, mdbModal, mdbModalBody, mdbModalFooter, mdbModalHeader} from 'mdbvue';

import fullCalendar from "@fullcalendar/vue"
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list';
import editor from '@tinymce/tinymce-vue'
import YesNoModal from "../common/YesNoModal";
import {Datetime} from 'vue-datetime'
import moment from 'moment'
import {Compact} from 'vue-color'
import Vue from "vue";

export default {
  name: "group-calendar",
  display: "Group Calendar",
  order: 1,
  components: {
    mdbContainer,
    mdbModal,
    mdbModalHeader,
    mdbModalFooter,
    mdbBtn,
    mdbModalBody,
    mdbIcon,
    mdbInput,
    fullCalendar,
    editor,
    YesNoModal,
    Datetime,
    Compact
  },
  watch: {
    includeTasks(a, b) {
      //this.$refs.calendar.fireMethod('refetch-events')
      let calendarApi = this.$refs.calendar.getApi()
      calendarApi.refetchEvents()
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    userDetails() {
      return this.$store.state.userDetails
    },
    currentGroup() {
      return this.$store.state.currentGroup
    },
    userTimeFormat() {
      let ret = {hour: 'numeric', minute: '2-digit', meridiem: 'short'}
      if (!this.userDetails || this.userDetails.timeFormat == "24 Hour") ret = {
        hour: '2-digit',
        minute: '2-digit',
        meridiem: false,
        hour12: false
      }
      return ret
    },
    allowNoteEdit() {
      if (this.currentGroup.role == "Admin" ||
        this.currentGroup.role == "Group Organizer" ||
        this.currentGroup.role == "Event Organizer") return true
      else return false
    }
  },
  data() {
    return {
      tooltipElement: null,
      showModal: false,
      noteTitle: "",
      noteBody: "",
      noteId: "",
      showNoteEdit: false,
      deleteRequested: false,
      savedEvent: null,
      colors: {
        hex: '#194d33'
      },
      workingNote: {
        id: null,
        title: "",
        text: "",
        startDate: null,
        endDate: null,
        hexColor: "#194d33"
      },

      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'a dayGridMonth,a dayGridWeek,a dayGridDay, a listMonth'
      },
      editorConfig: {
        browser_spellcheck: true,
        branding: false,
        plugins: ["link", "code", "paste", "table", "lists"],
        toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | link unlink code "],
        style_formats_merge: true,
        paste_as_text: true,
        relative_urls: false,
        remove_script_host: false,
        height: 400
      },
      includeTasks: false,
      //views: ['dayGridMonth','dayGridWeek'],

      events: (info, success, failure) => {
        let url = "/group/calendar/" + this.currentGroup.vanityPath + "?start=" + info.startStr + "&end=" + info.endStr
        if (this.includeTasks) url += "&tasks=Y"
        this.$store.dispatch("setExecuting", true)
        api.get(url).then(
          (details) => {
            success(details.data)
          },
          (error) => {
            if (error.response.status == 403) {
              this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
              return
            }
            this.$notify.error({message: "Error getting calendar data."})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      calendarPlugins: [dayGridPlugin, listPlugin]
    }
  },
  async beforeMount() {
    await this.$store.dispatch("setExecuting", true)
    await api.groupBasics(this.$route.params.id, "member")
    if (!this.currentGroup) {
      await this.$store.dispatch("setExecuting", false)
      this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
      return
    }
  },
  mounted() {
    document.title = "Group Calendar"
    api.trackGroupVisit(this.$route.params.id)
  },
  methods: {
    colorChange: function (c) {
      this.workingNote.hexColor = c.hex
    },
    print: function () {
      window.print()
    },
    saveNote: function () {
      this.showNoteEdit = false
      this.$store.dispatch("setExecuting", true)
      api.post("/group/calendarNote/" + this.currentGroup.id, this.workingNote).then(
        (details) => {
          this.$refs.calendar.getApi().refetchEvents()
          this.$refs.calendar.getApi().gotoDate(this.workingNote.startDate)
        },
        (error) => {
          this.showNoteEdit = true
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    addNote: function () {
      this.workingNote.title = ""
      this.workingNote.text = ""
      this.workingNote.id = null
      this.workingNote.hexColor = '#194d33'
      this.colors.hex = this.workingNote.hexColor
      this.workingNote.startDate = moment().format()
      this.workingNote.endDate = null
      this.showNoteEdit = true
      Vue.nextTick().then(function () {
        let element = document.getElementById("noteTitle")
        element.focus()
      })
    },
    doDeleteNote: function () {
      this.deleteRequested = false;
      this.showNoteEdit = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/group/calendarNote/" + this.workingNote.id).then(
        (details) => {
          this.savedEvent.remove()
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    editNote: function () {
      this.workingNote.title = this.savedEvent.title
      this.workingNote.id = this.savedEvent.id
      this.workingNote.text = this.savedEvent.extendedProps.description
      this.workingNote.startDate = moment(this.savedEvent.start).format()
      this.workingNote.endDate = moment(this.savedEvent.end).format()
      this.workingNote.hexColor = this.savedEvent.backgroundColor
      this.colors.hex = this.savedEvent.backgroundColor
      this.showModal = false
      this.showNoteEdit = true
      Vue.nextTick().then(function () {
        let element = document.getElementById("noteTitle")
        element.focus()
      })

    },
    eventClick: function (data) {
      data.jsEvent.preventDefault()
      if (data.event.extendedProps && ('description' in data.event.extendedProps)) {
        this.savedEvent = data.event
        this.noteTitle = data.event.title
        this.noteBody = data.event.extendedProps.description
        this.showModal = true
      } else {
        this.$router.push(data.event.url)
      }
    },
    mouseEnter: function (data) {
      if (document.documentElement.clientWidth < 1024) return
      let tip = document.getElementById("tooltip")
      if (!tip) return
      tip.innerHTML = data.el.innerText
      tip.style.position = "absolute"
      tip.style.left = data.jsEvent.pageX - 150 + "px"
      tip.style.top = data.jsEvent.pageY - 140 + "px"
      if (tip.style.left < 0) tip.style.left = "0px"
      if (tip.style.top < 0) tip.style.top = "0px";
      tip.style.display = "block"
      tip.style.backgroundColor = data.event.backgroundColor
      tip.style.border = "2px solid #000000"

    },
    mouseExit: function (data, event, view) {
      if (document.documentElement.clientWidth < 1024) return
      let tip = document.getElementById("tooltip")
      if (!tip) return
      tip.style.display = "none"
    },
  }

};
</script>

<style lang='scss'>
@import '@fullcalendar/core/main.css';
@import '@fullcalendar/daygrid/main.css';
@import '@fullcalendar/list/main.css';

@media screen and (min-width: 750px) {
  .top-buttons {
    top: 0;
    position: absolute;
    right: 0;
    padding-top: 80px;
    padding-right: 20px;
  }
  .bottom-buttons {
    display: none;
  }
}

@media screen and (max-width: 749px) {
  .top-buttons {
    display: none;
  }
}

#tooltip {
  width: auto;
  height: auto;
  z-index: 10001;
  padding: 10px 10px 10px 10px;
  line-height: 200%;
  color: #ffffff;
}

@import '~vue-datetime/dist/vue-datetime.min';

</style>
